export default "__VITE_ASSET__7KYnnmzA__"